if (!customElements.get('page-anchor')) {
  class PageAnchor extends HTMLElement {
    connectedCallback() {
      PageAnchor.anchors.add(this);
      PageAnchor.setupClickHandler();
    }

    disconnectedCallback() {
      PageAnchor.anchors.delete(this);

      if (!PageAnchor.anchors.size && PageAnchor.isInitialized) {
        document.removeEventListener('click', PageAnchor.onDocumentClick);
        PageAnchor.isInitialized = false;
      }
    }

    static setupClickHandler() {
      if (PageAnchor.isInitialized) {
        return;
      }

      PageAnchor.isInitialized = true;
      document.addEventListener('click', PageAnchor.onDocumentClick);
    }

    static onDocumentClick(event) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;

      if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) {
        return;
      }

      const target = PageAnchor.getTargetFromLink(link);

      if (!target) {
        return;
      }

      event.preventDefault();
      PageAnchor.scrollToTarget(target);
      PageAnchor.updateHistory(target);
    }

    static getTargetFromLink(link) {
      const href = link.getAttribute('href');

      if (!href || !href.includes('#')) {
        return null;
      }

      let targetId;

      if (href.startsWith('#')) {
        if (href === '#') {
          return null;
        }

        try {
          targetId = decodeURIComponent(href.slice(1));
        } catch {
          targetId = href.slice(1);
        }
      } else {
        let url;

        try {
          url = new URL(href, window.location.href);
        } catch {
          return null;
        }

        const normalizePath = (path) => path.replace(/\/$/, '');

        if (
          url.origin !== window.location.origin ||
          normalizePath(url.pathname) !== normalizePath(window.location.pathname) ||
          url.search !== window.location.search ||
          !url.hash ||
          url.hash === '#'
        ) {
          return null;
        }

        try {
          targetId = decodeURIComponent(url.hash.slice(1));
        } catch {
          targetId = url.hash.slice(1);
        }
      }

      const target = document.getElementById(targetId);

      if (!target || target.tagName.toLowerCase() !== 'page-anchor') {
        return null;
      }

      return target;
    }

    static scrollToTarget(target) {
      window.scrollTo({
        top: PageAnchor.getTargetScrollPosition(target),
        behavior: PageAnchor.prefersReducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    static getTargetScrollPosition(target) {
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const scrollMarginTop = Number.parseFloat(window.getComputedStyle(target).scrollMarginTop);
      const stickyHeader = document.querySelector('sticky-header');
      const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
      const targetOffset = Math.max(
        Number.isNaN(scrollMarginTop) ? 0 : scrollMarginTop,
        stickyHeaderHeight
      );

      return Math.max(targetTop - targetOffset, 0);
    }

    static updateHistory(target) {
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', `#${target.id}`);
        return;
      }

      window.location.hash = target.id;
    }
  }

  PageAnchor.isInitialized = false;
  PageAnchor.anchors = new Set();
  PageAnchor.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  customElements.define('page-anchor', PageAnchor);
}
